export class ManagerModel {
    _id: string;
    FirstName: string;
    LastName: string;
    MobileNumber: string;
    EmailAddress: string;
    Password: string;
    PasswordConfirmation: string;
}
